import { z } from 'zod';

export const EmailsSchema = z
  .array(z.string().email('Kontrollera e-posterna'))
  .min(1, 'Ange minst en e-post')
  .max(10, 'Du får max ange 10 e-poster');
